var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-modal-contents", {
        ref: "modal_contents_agree",
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title mt-30 pl-3 " }, [
                  _vm.language == "ru"
                    ? _c("div", { staticClass: "h2_title" }, [
                        _vm._v("Пользовательское соглашение!"),
                      ])
                    : _vm.language == "en"
                    ? _c("div", { staticClass: "h2_title" }, [
                        _vm._v("Terms of use!"),
                      ])
                    : _vm._e(),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _vm.language == "ru"
                    ? _c("p", { staticClass: "red" }, [
                        _vm._v("ТЕКСТ НАХОДИТСЯ В РАЗРАБОТКЕ"),
                      ])
                    : _vm.language == "en"
                    ? _c("p", { staticClass: "red" }, [
                        _vm._v("TEXT IS UNDER DEVELOPMENT"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-30" }, [
                    _vm.language == "ru"
                      ? _c(
                          "button",
                          {
                            staticClass: "px-30 btn_bordered ",
                            on: {
                              click: function ($event) {
                                return _vm.$refs.modal_contents_agree.modal_open()
                              },
                            },
                          },
                          [_vm._v("\n            Прочитал\n          ")]
                        )
                      : _vm.language == "en"
                      ? _c(
                          "button",
                          {
                            staticClass: "px-30 btn_bordered",
                            on: {
                              click: function ($event) {
                                return _vm.$refs.modal_contents_agree.modal_open()
                              },
                            },
                          },
                          [_vm._v("\n            Read\n          ")]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "form_upload",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 col-md-6 py-0" }, [
              _c(
                "div",
                { staticClass: "form_upload__item" },
                [
                  _vm.language == "ru"
                    ? _c("label", { attrs: { for: "name" } }, [
                        _vm._v("ФИО "),
                        _c("span", { staticClass: "red" }, [_vm._v(" *")]),
                      ])
                    : _vm.language == "en"
                    ? _c("label", { attrs: { for: "name" } }, [
                        _vm._v("Full name "),
                        _c("span", { staticClass: "red" }, [_vm._v(" *")]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.language == "ru"
                    ? _c("v-text-field", {
                        attrs: {
                          rules: _vm.nameRulesRu,
                          required: "",
                          solo: "",
                          id: "name",
                        },
                        model: {
                          value: _vm.name,
                          callback: function ($$v) {
                            _vm.name = $$v
                          },
                          expression: "name",
                        },
                      })
                    : _vm.language == "en"
                    ? _c("v-text-field", {
                        attrs: {
                          rules: _vm.nameRules,
                          required: "",
                          solo: "",
                          id: "name",
                        },
                        model: {
                          value: _vm.name,
                          callback: function ($$v) {
                            _vm.name = $$v
                          },
                          expression: "name",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-6 py-0" }, [
              _c(
                "div",
                { staticClass: "form_upload__item item_tel position-relative" },
                [
                  _vm.language == "ru"
                    ? _c("label", { attrs: { for: "tel" } }, [
                        _vm._v("Телефон "),
                        _c("span", { staticClass: "red" }, [_vm._v(" *")]),
                      ])
                    : _vm.language == "en"
                    ? _c("label", { attrs: { for: "tel" } }, [
                        _vm._v("Телефон "),
                        _c("span", { staticClass: "red" }, [_vm._v(" *")]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.language == "ru"
                    ? _c("v-text-field", {
                        staticClass: "tel_input",
                        attrs: {
                          rules: _vm.tel_inputRulesRu,
                          required: "",
                          solo: "",
                          id: "tel",
                          oninput:
                            "this.value = this.value.replace(/[^\\d]/g,'');",
                        },
                        model: {
                          value: _vm.tel_input,
                          callback: function ($$v) {
                            _vm.tel_input = $$v
                          },
                          expression: "tel_input",
                        },
                      })
                    : _vm.language == "en"
                    ? _c("v-text-field", {
                        staticClass: "tel_input",
                        attrs: {
                          rules: _vm.tel_inputRules,
                          required: "",
                          solo: "",
                          id: "tel",
                          oninput:
                            "this.value = this.value.replace(/[^\\d]/g,'');",
                        },
                        model: {
                          value: _vm.tel_input,
                          callback: function ($$v) {
                            _vm.tel_input = $$v
                          },
                          expression: "tel_input",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-select", {
                    staticClass: "tel_sel__btn d-flex align-items-center",
                    attrs: {
                      items: _vm.tel_items,
                      "menu-props": { contentClass: "wrap_selfilter" },
                      "item-value": "sel_id",
                      solo: "",
                      "append-icon": "mdi mdi-chevron-down",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function (data) {
                          return [
                            _c("img", { attrs: { src: data.item.icon } }),
                            _vm._v(" "),
                            _c("span", { staticClass: "tel_kod" }, [
                              _vm._v(_vm._s(data.item.kod)),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "item",
                        fn: function (data) {
                          return [
                            _c("img", {
                              staticClass: "pr-2",
                              attrs: { src: data.item.icon },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(data.item.name))]),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.defaultSelectedTel.sel_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.defaultSelectedTel, "sel_id", $$v)
                      },
                      expression: "defaultSelectedTel.sel_id",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-6 py-0" }, [
              _c(
                "div",
                { staticClass: "form_upload__item" },
                [
                  _vm.language == "ru"
                    ? _c("label", { attrs: { for: "name" } }, [
                        _vm._v("Город "),
                        _c("span", { staticClass: "red" }, [_vm._v(" *")]),
                      ])
                    : _vm.language == "en"
                    ? _c("label", { attrs: { for: "name" } }, [
                        _vm._v("City "),
                        _c("span", { staticClass: "red" }, [_vm._v(" *")]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.language == "ru"
                    ? _c("v-text-field", {
                        attrs: {
                          rules: _vm.cityRulesRu,
                          required: "",
                          solo: "",
                          id: "name",
                        },
                        model: {
                          value: _vm.city,
                          callback: function ($$v) {
                            _vm.city = $$v
                          },
                          expression: "city",
                        },
                      })
                    : _vm.language == "en"
                    ? _c("v-text-field", {
                        attrs: {
                          rules: _vm.cityRules,
                          required: "",
                          solo: "",
                          id: "name",
                        },
                        model: {
                          value: _vm.city,
                          callback: function ($$v) {
                            _vm.city = $$v
                          },
                          expression: "city",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-6 py-0" }, [
              _c(
                "div",
                { staticClass: "form_upload__item" },
                [
                  _c("label", { attrs: { for: "email" } }, [
                    _vm._v("E-mail "),
                    _c("span", { staticClass: "red" }, [_vm._v(" *")]),
                  ]),
                  _vm._v(" "),
                  _vm.language == "ru"
                    ? _c("v-text-field", {
                        attrs: {
                          rules: _vm.emailRulesRu,
                          required: "",
                          solo: "",
                          id: "email",
                        },
                        model: {
                          value: _vm.email,
                          callback: function ($$v) {
                            _vm.email = $$v
                          },
                          expression: "email",
                        },
                      })
                    : _vm.language == "en"
                    ? _c("v-text-field", {
                        attrs: {
                          rules: _vm.emailRules,
                          required: "",
                          solo: "",
                          id: "email",
                        },
                        model: {
                          value: _vm.email,
                          callback: function ($$v) {
                            _vm.email = $$v
                          },
                          expression: "email",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-6 py-0" }, [
              _c(
                "div",
                { staticClass: "form_upload__item item_tel position-relative" },
                [
                  _vm.language == "ru"
                    ? _c("label", { attrs: { for: "type_of_appeal" } }, [
                        _vm._v("Выберите удобный вид связи"),
                      ])
                    : _vm.language == "en"
                    ? _c("label", { attrs: { for: "type_of_appeal" } }, [
                        _vm._v("Choose a convenient way of communication"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-select", {
                    staticClass: " d-flex align-items-center",
                    attrs: {
                      items: _vm.type_appeal,
                      "menu-props": { contentClass: "wrap_selfilter" },
                      "item-value": "sel_id",
                      solo: "",
                      "append-icon": "mdi mdi-chevron-down",
                      id: "type_of_appeal",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function (data) {
                          return [
                            _c("img", { attrs: { src: data.item.icon } }),
                            _vm._v(" "),
                            _vm.language == "ru"
                              ? _c("span", { staticClass: "pl-2" }, [
                                  _vm._v(_vm._s(data.item.name)),
                                ])
                              : _vm.language == "en"
                              ? _c("span", { staticClass: "pl-2" }, [
                                  _vm._v(_vm._s(data.item.eng_name)),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "item",
                        fn: function (data) {
                          return [
                            _c("img", { attrs: { src: data.item.icon } }),
                            _vm._v(" "),
                            _vm.language == "ru"
                              ? _c("span", { staticClass: "pl-2" }, [
                                  _vm._v(_vm._s(data.item.name)),
                                ])
                              : _vm.language == "en"
                              ? _c("span", { staticClass: "pl-2" }, [
                                  _vm._v(_vm._s(data.item.eng_name)),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.type_appeal_sel.sel_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.type_appeal_sel, "sel_id", $$v)
                      },
                      expression: "type_appeal_sel.sel_id",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-12 py-0" }, [
              _c(
                "div",
                {
                  staticClass:
                    "form_upload__item d-flex align-items-center justify-content-between mt-5",
                },
                [
                  _vm.language == "ru"
                    ? _c("v-checkbox", {
                        attrs: {
                          rules: [
                            function (v) {
                              return (
                                !!v ||
                                "Вы должны подтвердить прочтение соглашения!"
                              )
                            },
                          ],
                          required: "",
                          color: "red",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n              Я подтверждаю, что прочитал "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "mx-1",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$refs.modal_contents_agree.modal_open(
                                            "scroll_false"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("соглашение")]
                                  ),
                                  _vm._v(
                                    "\n              и согласен с ним.\n            "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3654775974
                        ),
                        model: {
                          value: _vm.checkbox,
                          callback: function ($$v) {
                            _vm.checkbox = $$v
                          },
                          expression: "checkbox",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.language == "en"
                    ? _c("v-checkbox", {
                        attrs: {
                          rules: [
                            function (v) {
                              return !!v || "You must agree to continue!"
                            },
                          ],
                          required: "",
                          color: "red",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n              I confirm that I have read "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "mx-1",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$refs.modal_contents_agree.modal_open(
                                            "scroll_false"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("the\n              agreement")]
                                  ),
                                  _vm._v(" and agree with it.\n            "),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          690787725
                        ),
                        model: {
                          value: _vm.checkbox,
                          callback: function ($$v) {
                            _vm.checkbox = $$v
                          },
                          expression: "checkbox",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btn_form" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "px-30 btn_red",
                          attrs: { disabled: !_vm.valid },
                          on: { click: _vm.sendForm },
                        },
                        [
                          _vm.language == "ru"
                            ? _c("span", [_vm._v("Отправить")])
                            : _vm.language == "en"
                            ? _c("span", [_vm._v("Send")])
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }